import script from "./SiteCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteCarousel.vue?vue&type=script&setup=true&lang=js"

import "./SiteCarousel.vue?vue&type=style&index=0&id=c8d7cd74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8d7cd74"]])

export default __exports__